module.exports = __webpack_public_path__ + "img/fx.73afed4e.png";